import { cn } from '@/components/ui/cn';
import { Text, type TextProps } from '@/components/ui/Text';

/** Bakes `font-sans-semibold`; size/color are passed per call. */
export const BodySemibold = (p: TextProps) => (
  <Text variant="none" {...p} className={cn('font-sans-semibold', p.className)} />
);
